import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import { msalInstance, initializeMsal } from './config/msalConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Initialize MSAL first, then render
initializeMsal().then(() => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});